import 'css-chunk:src/badge/style.module.scss';export default {
  "badge": "a8cui-DPKqWs",
  "is-default": "a8cui-3Ut0Se",
  "has-icon": "a8cui-JRVFdH",
  "is-info": "a8cui-1y4b5l",
  "is-warning": "a8cui-PT-ZdX",
  "is-error": "a8cui-eTS5AQ",
  "is-success": "a8cui-A8MMKo",
  "badge__icon": "a8cui-fZ9W2S",
  "badge__content": "a8cui-phpszl"
};